<template>
	<div>
		<div :class="['form-group', $style.fileArea]">
			<input
				id="images"
				ref="fileInput"
				type="file"
				name="images"
				:accept="tipos.join(',')"
				required="required"
				@change="archivos"
			/>
			<div :class="$style.fileDummy">
				<div :class="$style.success">
					<div v-for="file in files" :key="file.name" :class="$style.file">
						<div :class="$style.text">
							<i class="file icon"></i><br />
							<span class="ftext">
								{{ file.name }}
							</span>
						</div>
					</div>
				</div>
				<div :class="[$style.default, $style.texto]">
					<div :class="$style.icono">
						<i class="upload icon"></i>
					</div>
					<div :class="$style.titulo">{{ titulo }}</div>
					<p>{{ subtitulo }}</p>
				</div>
			</div>
		</div>
		<div v-if="false" :class="$style.dangerColor">
			<i class="info circle icon"></i>
			Solo se pueden subir archivos tipo .csv
		</div>
	</div>
</template>

<script>
import Notification from '@utils/notification';
export default {
	props: {
		value: {
			type: [FileList, Array],
			default: () => []
		},
		open: {
			type: Boolean,
			default: false
		},
		titulo: {
			type: String,
			default: 'Titulo'
		},
		subtitulo: {
			type: String,
			default: 'Subtitulo'
		},
		tipos: {
			type: [Array, String],
			default: () => ['text/csv', 'application/vnd.ms-excel', '.csv']
		}
	},
	data() {
		return {
			files: [],
			archivosNoAceptados: false
		};
	},
	watch: {
		value: function(val) {
			if (val.length !== this.files.length) {
				this.files = val;
				if (this.files.length === 0 && this.$refs.fileInput)
					this.$refs.fileInput.value = '';
			}
		},
		open: function(val) {
			if (!this.open) {
				this.archivosNoAceptados = false;
			}
		}
	},
	mounted() {},
	methods: {
		archivos(event) {
			const archivos = [...event.target.files];
			const permitir = (x) => this.tipos.includes(x.type);
			const permitirTodo = () => true;
			const tipos = this.tipos.length > 0;
			const permitidos = archivos.filter(tipos ? permitir : permitirTodo);

			this.archivosNoAceptados = ((x, y) => x.length !== y.length)(
				archivos,
				permitidos
			);

			if (this.archivosNoAceptados && this.$refs.fileInput) {
				this.$refs.fileInput.value = '';
				Notification('error', 'Solo se permiten archivos CSV');
			}

			this.files = permitidos;
			this.$emit('input', permitidos);
		}
	}
};
</script>

<style lang="scss" module>
@import '@design';
.texto {
	.titulo {
		font-size: 25px;
	}

	.ftext {
		display: block;
		margin-top: 10px;
	}
}
.icono {
	font-size: 50px;
}

.file {
	display: flex;
	justify-content: center;
	width: 130px;
	height: 130px;
	margin: 5px;
	border: 1px solid rgb(233, 233, 233);
	border-radius: 5px;

	.text {
		margin-top: 40px;
		word-break: break-all;

		i {
			font-size: 20px;
		}
	}
}

.fileArea {
	position: relative;
	width: 100%;

	input[type='file'] {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 100%;
		cursor: pointer;
		opacity: 0;
	}

	.fileDummy {
		width: 100%;
		padding: 30px;
		text-align: center;
		background: rgba(255, 255, 255, 0.2);
		border: 2px dashed #c0ccda;
		border-radius: 10px;
		transition: background 0.3s ease-in-out;

		.success {
			display: none;
			justify-content: center;
		}
	}

	&:hover .fileDummy {
		background: rgba(255, 255, 255, 0.1);
	}

	input[type='file']:focus + .fileDummy {
		outline: 2px solid rgba(255, 255, 255, 0.5);
		outline: -webkit-focus-ring-color auto 5px;
	}

	input[type='file']:valid + .fileDummy {
		.success {
			display: flex;
			flex-wrap: wrap;
		}

		.default {
			display: none;
		}
	}
}

.dangerColor {
	margin-top: 20px;
	color: $background-danger;
}
</style>
